<template>
  <iframe
    v-if="isPhone"
    :src="supportUrl"
    title="officialSupport-page"
    id="officialSupport-page"
    class="officialSupport-page"
  ></iframe>
  <div v-else id="officialSupport-page" class="officialSupport-page pc">
    <!-- <div class="header">
      <div class="header-main">
        <div class="lang-choose">
          <Select
            class="lang-choose-select"
            v-model="curLang"
            @change="changeLang"
            v-show="visibleLangChoose"
          >
            <option
              v-for="(text, langVal) in langList"
              :key="langVal"
              :value="langVal"
            >
              {{ text }}
            </option>
          </Select>
        </div>
      </div>
    </div> -->
    <div class="main">
      <iframe
        ref="officialSupportIframe"
        :src="supportUrl"
        title="officialSupport-page"
        id="officialSupport-page"
        class="officialSupport-page"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { CHECK_IP_LOCATION } from '@store/ipCheck';
import globalConfig from '@utiles/globalConfig';
import { judgeIsSameMainHost, isFn } from '@utiles/index';
import { isPhone } from '@utiles/device';
import Select from '@components/officialSupport/common/Select.vue';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();
export default {
  data() {
    let curSupportUrl = window.location.href.replace(
      /webOfficialSupport/,
      'officialSupport'
    );
    if (
      window.location.hash &&
      window.location.hash.indexOf('#/worktemp') === -1
    ) {
      curSupportUrl = curSupportUrl.replace(window.location.hash, '');
    }
    if (globalConfig.isUidGame()) {
      let curGameId = globalConfig.getUidGameId(window.location.host);
      if (curGameId) {
        curSupportUrl += `${
          !!~curSupportUrl.indexOf('?') ? '&' : '?'
        }gameId=${curGameId}`;
      }
    }
    curSupportUrl = globalConfig.hrefAddParam(
      curSupportUrl,
      'inWebOfficialSupport',
      '1'
    );
    return {
      supportUrl: getGlobalGetGotoLink({ link: curSupportUrl }),
      isPhone: isPhone(),
      curLang: '',
      langList: {},
      visibleLangChoose: true
    };
  },
  beforeCreate() {
    // 泰越斗罗h5：泰国地区域名跳转
    if (mainHost === atob('c2xmdW50YXAuY29t')) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res.ISO_TWO_CODE == 'TH') {
          window.location.href = window.location.href.replace(
            new RegExp(atob('c2xmdW50YXAuY29t')),
            atob('ZW5kb21haW5uYW1lLmNvbQ==')
          );
        }
      });
    }
  },
  created() {
    globalConfig.addEvenListener(this.listenerHandle, 'message');
  },
  methods: {
    listenerHandle(e) {
      const evt = e || event;
      const data = evt?.data;
      const ACTION_MAP = {
        setSkinStyle: this.setSkinStyle,
        setLang: this.setLang,
        setLangList: this.setLangList,
        visibleLangChoose: this.handleVisibleLangChoose,
        locationLink: this.locationLink
      };
      const action = data?.action;
      const value = data?.value;
      // 忽略来自自身的消息
      if (evt.source === window) {
        return;
      }
      if (['createWorkSucc', 'goBack'].includes(action)) {
        this.postMessageToParent(action, value);
        return;
      }
      const handleFn = ACTION_MAP[action];
      if (
        handleFn &&
        judgeIsSameMainHost(evt.origin, window.location.origin) &&
        isFn(handleFn)
      ) {
        handleFn(value);
      }
    },
    setSkinStyle(styleStr) {
      const styleEle = document.createElement('style');
      styleEle.innerHTML = styleStr;
      document.head.appendChild(styleEle);
    },
    setLang(lang) {
      this.curLang = lang;
    },
    setLangList(list) {
      this.langList = list;
    },
    changeLang(value) {
      this.$refs.officialSupportIframe.contentWindow.postMessage(
        {
          action: 'changeLang',
          value: value
        },
        '*'
      );
    },
    handleVisibleLangChoose(visible) {
      this.visibleLangChoose = visible;
    },
    postMessageToParent(action, value) {
      window.parent.postMessage(
        {
          action,
          value
        },
        '*'
      );
    },
    locationLink(url) {
      window.location.href = url;
    }
  },
  components: {
    Select
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/base.scss';
@import '../../assets/scss/webOfficialSupport.scss';
</style>
